import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Chip, useTheme } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
const iconSize = (width, height) => ({
    fontSize: height.value,
    lineHeight: height.value,
    width: width.value,
    height: width.value,
});
const createStates = (state) => {
    const { defaultState, hover, active } = state;
    return Object.assign(Object.assign({}, applyTokens(defaultState)), { "&:not(.Mui-disabled):hover": Object.assign({}, applyTokens(hover)), "&:not(.Mui-disabled):active": Object.assign({}, applyTokens(active)) });
};
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
const ButtonTile = (_a) => {
    var props = __rest(_a, []);
    const { sx, muted, size, statusIndicatorProps } = props;
    const { tokens } = useTheme();
    const { buttonTile, statusIndicator } = tokens.component;
    const { semantic, core } = tokens;
    const { default: defaultState, hover, active, focus, icon, disabled } = buttonTile;
    function ButtonTileStatusIndicator({ color, disabled, }) {
        const ButtonTileStatusIndicatorStyles = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, applyTokens(statusIndicator)), applyTokens(buttonTile.statusIndicator[color])), { "& .MuiChip-label": Object.assign({}, applyTokens(statusIndicator.label)) }), (disabled ? applyTokens(buttonTile.statusIndicator.disabled) : {})), (size === "large"
            ? { position: "absolute", top: core.spacing[1].value, right: core.spacing[1].value }
            : {}));
        return _jsx(Chip, { label: capitalizeFirstLetter(color), sx: ButtonTileStatusIndicatorStyles });
    }
    const ButtonTileStyles = Object.assign(Object.assign(Object.assign({ border: `${semantic.borderWidth.thin.value} solid transparent` }, (size === "small" && { whiteSpace: "nowrap" })), createStates({
        defaultState,
        hover,
        active,
        disabled,
    })), { "&:focus": Object.assign({}, applyTokens(focus)), "&.MuiButton-sizeSmall": Object.assign(Object.assign({}, applyTokens(buttonTile.sizes.small)), { "& .MuiButton-startIcon": Object.assign(Object.assign({ margin: 0 }, iconSize(semantic.iconSize.lg, semantic.iconSize.lg)), { "--atlas-icon-size": "lg" }) }), "&.MuiButton-sizeLarge": Object.assign(Object.assign({}, applyTokens(buttonTile.sizes.large)), { display: "flex", flexDirection: "column", "& .MuiButton-startIcon": Object.assign(Object.assign({ margin: 0 }, iconSize(semantic.iconSize.xl, semantic.iconSize.xl)), { "--atlas-icon-size": "xl" }) }), "& .MuiButton-startIcon": {
            color: muted ? icon.muted.color.value : icon.color.value,
        }, "&.Mui-disabled": Object.assign(Object.assign({}, applyTokens(disabled)), { "& .MuiButton-startIcon": {
                color: icon.disabled.color.value,
            } }) });
    return (_jsxs(Button, Object.assign({}, props, { sx: Object.assign(Object.assign({}, ButtonTileStyles), sx) }, { children: [size === "large" ? (_jsx(Box, Object.assign({ component: "span", sx: { height: buttonTile.sizes.large.label.height.value } }, { children: props.children }))) : (props.children), statusIndicatorProps && (_jsx(ButtonTileStatusIndicator, { color: statusIndicatorProps.type, disabled: statusIndicatorProps.disabled }))] })));
};
export const ButtonTilePresets = {
    components: {
        ButtonTile,
    },
};
//# sourceMappingURL=buttonTile.js.map